module.exports = __webpack_public_path__ + "static/367117_1_0-57ec77c6a2dc5e2d3e9c10de5939c4a4.eot";